// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.3);
  background-repeat: no-repeat;
  background-size: cover;
  --ion-text-color: #000;
}

ion-input.input-head {
  text-align: center !important;
  font-size: 26px !important;
  --color: white !important;
  --placeholder-color: white;
  --placeholder-font-style: normal;
  --placeholder-font-weight: 300 !important;
  font-family: "Montserrat", sans-serif !important;
  line-height: 30px !important;
}

ion-card-title {
  font-size: 20px;
}

ion-datetime.datetime-head {
  text-align: center !important;
  font-family: "Montserrat", sans-serif !important;
  color: white !important;
  font-weight: 400;
  padding-top: 25px !important;
  padding-bottom: 25px !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

ion-back-button {
  --color: var(--ion-color-secondary);
  --icon-margin-start: 0px;
  --icon-padding-start: 0px;
  --margin-start: 0px;
  --padding-start: 0px;
}

ion-item {
  --color: var(--ion-color-dark);
}

ion-input {
  text-align: right;
}

ion-avatar {
  margin-right: 10px;
  max-width: 40px;
  max-height: 40px;
}

.container-calendar {
  background: #ffffff;
  margin: 18px;
  padding: 7px;
}

.select-access {
  margin-bottom: 30px;
  /* color: #FFF; */
  padding: 37px 40px;
  position: relative;
  box-shadow: 0px 13px 40px -20px #c3c3c3;
}

.select-text {
  opacity: 1;
}

ion-button {
  --background: var(--ion-color-secondary);
  --ion-color-base: #ffffff !important;
}
ion-button.button-disabled {
  opacity: 0.5;
  --opacity: .5;
}

ion-footer {
  background: var(--ion-color-secondary);
}

h1 {
  font-size: 22px;
}

.button-inner {
  justify-content: flex-end;
}

.save-icon {
  margin-right: 10px;
}

.check-avaibility-btn {
  --box-shadow: none;
  border: none;
  box-shadow: none;
  height: 30px;
  margin-bottom: 35px;
  margin-top: 0;
}

.credit-container {
  text-align: right;
  margin-right: 11px;
  --min-height: 30px;
  font-size: 15px;
}
.credit-container .credit {
  margin-left: 5px;
  color: var(--ion-color-primary);
}

ion-datetime {
  --background: #ffffff;
  --background-rgb: 255, 255, 255;
  border-radius: 7px;
  --wheel-highlight-background: rgba(var(--ion-color-secondary-rgb), .1);
}

ion-modal {
  --backdrop-opacity: 0.3!important;
  --border-radius: 7px;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/new-booking/new-booking.page.scss"],"names":[],"mappings":"AAAA;EACE,iDAAA;EACA,4BAAA;EACA,sBAAA;EACA,sBAAA;AACF;;AAEA;EACE,6BAAA;EACA,0BAAA;EACA,yBAAA;EACA,0BAAA;EACA,gCAAA;EACA,yCAAA;EACA,gDAAA;EACA,4BAAA;AACF;;AACA;EACE,eAAA;AAEF;;AAAA;EACE,6BAAA;EAEA,gDAAA;EACA,uBAAA;EACA,gBAAA;EACA,4BAAA;EACA,+BAAA;EACA,0BAAA;EACA,6BAAA;AAEF;;AACA;EACE,mCAAA;EACA,wBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;AAEF;;AACA;EACE,8BAAA;AAEF;;AACA;EACE,iBAAA;AAEF;;AACA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;AAEF;;AAIA;EAEE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uCAAA;AAFF;;AAKA;EACE,UAAA;AAFF;;AAKA;EACE,wCAAA;EACA,oCAAA;AAFF;AAGE;EACE,YAAA;EACA,aAAA;AADJ;;AAKA;EACE,sCAAA;AAFF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,yBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AAHF;;AAKA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAFF;AAGE;EACE,gBAAA;EACA,+BAAA;AADJ;;AAKA;EACE,qBAAA;EACA,+BAAA;EAEA,kBAAA;EAEA,sEAAA;AAJF;;AAOA;EACE,iCAAA;EACA,oBAAA;AAJF","sourcesContent":["ion-header {\n  box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.3);\n  background-repeat: no-repeat;\n  background-size: cover;\n  --ion-text-color: #000;\n}\n\nion-input.input-head {\n  text-align: center !important;\n  font-size: 26px !important;\n  --color: white !important;\n  --placeholder-color: white;\n  --placeholder-font-style: normal;\n  --placeholder-font-weight: 300 !important;\n  font-family: \"Montserrat\", sans-serif !important;\n  line-height: 30px !important;\n}\nion-card-title{\n  font-size: 20px;\n}\nion-datetime.datetime-head {\n  text-align: center !important;\n\n  font-family: \"Montserrat\", sans-serif !important;\n  color: white !important;\n  font-weight: 400;\n  padding-top: 25px !important;\n  padding-bottom: 25px !important;\n  margin-top: 0px !important;\n  margin-bottom: 0px !important;\n}\n\nion-back-button {\n  --color: var(--ion-color-secondary);\n  --icon-margin-start: 0px;\n  --icon-padding-start: 0px;\n  --margin-start: 0px;\n  --padding-start: 0px;\n}\n\nion-item {\n  --color: var(--ion-color-dark);\n}\n\nion-input {\n  text-align: right;\n}\n\nion-avatar{\n  margin-right: 10px;\n  max-width: 40px;\n  max-height: 40px;\n}\n\n.container-calendar{\n  background: #ffffff;\n  margin: 18px;\n  padding: 7px;\n}\n\n.title-select-access{\n}\n\n.select-access{\n  //background: #09678c;\n  margin-bottom: 30px;\n  /* color: #FFF; */\n  padding: 37px 40px;\n  position: relative;\n  box-shadow: 0px 13px 40px -20px #c3c3c3;\n}\n\n.select-text{\n  opacity: 1;\n}\n\nion-button {\n  --background: var(--ion-color-secondary);\n  --ion-color-base: #ffffff !important;\n  &.button-disabled{\n    opacity: .5;\n    --opacity: .5;\n  }\n}\n\nion-footer {\n  background: var(--ion-color-secondary)\n}\n\n\nh1 {\n  font-size: 22px;\n}\n\n.button-inner{\n  justify-content: flex-end;\n}\n\n.save-icon{\n  margin-right: 10px;\n}\n\n.check-avaibility-btn{\n  --box-shadow: none;\n  border: none;\n  box-shadow: none;\n  height: 30px;\n  margin-bottom: 35px;\n  margin-top: 0;\n}\n.credit-container{\n  text-align: right;\n  margin-right: 11px;\n  --min-height: 30px;\n  font-size: 15px;\n  .credit{\n    margin-left: 5px;\n    color: var(--ion-color-primary);\n  }\n}\n\nion-datetime {\n  --background: #ffffff;\n  --background-rgb: 255, 255, 255;\n\n  border-radius: 7px;\n\n  --wheel-highlight-background: rgba(var(--ion-color-secondary-rgb), .1);\n}\n\nion-modal {\n  --backdrop-opacity: 0.3!important;\n  --border-radius: 7px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
